var classes = {"spinnerCircle":"vbt4M"};

export { classes as default };
